import { useCandidateRedux } from "#candidate/redux/slice"
import MainDetailsBody from "#core/components/main-details/MainDetailsBody"
import { TitleButton } from "#core/components/main-details/MainDetailsCommon"
import { Fragment, useState } from "react"
import { useNavigate } from "react-router-dom"
import { CandidateEditDateTimeDialog } from "../candidate-edit/CandidateEditDateTime"
import EditIcon from "@mui/icons-material/Edit"
import { STATUS } from "#candidate/constants"
import { UseHasPermission } from "#hooks/useHasPermission"
import PERMISOS from "#constants/perfiles"

export default function CandidateDetailsBody() {
	const { candidate } = useCandidateRedux()
	const navigate = useNavigate()
	const [open, setOpen] = useState(false)
	const isRh = UseHasPermission(PERMISOS.RH)
	const isAdmin = UseHasPermission()

	const edit_date = (status) =>
		candidate.status === status &&
		isRh &&
		candidate.is_enabled &&
		candidate.vacancy_active

	const fields = [
		{
			label: "Vacante",

			value: candidate.vacante,
			button: {
				label: "Vacante",
				title: "Ir a vacante",
				onClick: () => {
					navigate("/vacancy/" + candidate.vacante)
				},
			},
		},
		{
			label: "Colaborador",

			value: candidate.colaborador_no_empleado,
			button: {
				label: "Colaborador",
				title: "Ir a colaborador",
				onClick: () => {
					navigate("/colaboradores/" + candidate.colaborador_no_empleado)
				},
			},
		},

		{
			label: "Teléfono",
			value: candidate.celular,
		},
		{
			label: "correo",
			value: candidate.correo,
		},
		{
			label: "Entrevista de RH",

			value: candidate.interview_date_rh,
			button: {
				label: "Entrevista RH",
				title: "editar fecha",
				onClick: () => {
					setOpen("interview_date_rh")
				},
				icon: EditIcon,
				hidden: !edit_date(STATUS.SCHEDULED_BY_HR),
			},
		},
		{
			label: "Entrevista jefe",

			value: candidate.interview_date_boss,
			button: {
				label: "Entrevista jefe",
				title: "editar fecha",
				onClick: () => {
					setOpen("interview_date_boss")
				},
				icon: EditIcon,
				hidden: !edit_date(STATUS.SCHEDULED_BY_BOSS),
			},
		},

		{
			label: "Tiempo de traslado",
			value: candidate.commute_time,
		},
		{
			label: "otra deducción",
			value: candidate.other_deductions,
		},
		{
			label: "licencia valida",
			value: candidate.valid_license,
		},
		{
			label: "expectativa de salario",
			value: candidate.salary_expectation,
		},
		{
			label: "colaborador id",
			value: candidate.colaborador,
			hidden: !isAdmin,
		},
		{
			label: "Candidato final N°",
			value: candidate.ranking,
		},
	]

	return (
		<Fragment>
			<MainDetailsBody ItemsWrapper={fields} noUsePaper />
			<CandidateEditDateTimeDialog
				id={open}
				label="Entrevista"
				date={candidate?.[open]}
				open={!!open}
				setOpen={setOpen}
			/>
		</Fragment>
	)
}
